module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icn-empty-cart-885967416339a8e18b305de71d8fe1f3.svg";